import React, { useState } from "react";
import InvoicePreview from "./InvoicePreview";

const preStyle = {
  background: "#f8f9fa",
  padding: "8px",
  borderRadius: "4px",
  maxHeight: "320px",
  overflow: "auto",
  fontSize: "12px",
  marginTop: "8px",
  marginBottom: 0,
};

// Toggleable JSON / rendered-invoice view of a test_upload result
// ({ data, errors, truncated, matched } or { error }).
const TestResultView = ({ result }) => {
  const [view, setView] = useState("preview");

  if (result.error) {
    return <div className="alert alert-danger py-1 px-2 mt-2 mb-0 small">{result.error}</div>;
  }

  const data = result.data || {};

  return (
    <div className="mt-2">
      <div className="d-flex align-items-center justify-content-between">
        <div style={{ gap: "6px" }} className="d-flex align-items-center">
          <span className={`badge bg-${result.matched ? "success" : "secondary"}`}>
            {result.matched ? "Matched" : "Not matched"}
          </span>
          {result.truncated && <span className="badge bg-warning text-dark">Truncated</span>}
          {result.errors && result.errors.length > 0 && (
            <span className="badge bg-danger">{result.errors.length} field error(s)</span>
          )}
        </div>
        <div className="btn-group btn-group-sm" role="group">
          <button
            type="button"
            className={`btn btn-outline-secondary ${view === "preview" ? "active" : ""}`}
            onClick={() => setView("preview")}
          >
            Preview
          </button>
          <button
            type="button"
            className={`btn btn-outline-secondary ${view === "json" ? "active" : ""}`}
            onClick={() => setView("json")}
          >
            JSON
          </button>
          {result.ocr_format && (
            <button
              type="button"
              className={`btn btn-outline-secondary ${view === "ocr_format" ? "active" : ""}`}
              onClick={() => setView("ocr_format")}
            >
              OCR format
            </button>
          )}
        </div>
      </div>

      {result.errors && result.errors.length > 0 && (
        <ul className="small text-danger mt-1 mb-0">
          {result.errors.map((e, i) => (
            <li key={i}>
              {e.field ? `${e.field}: ` : ""}
              {e.message || e.kind}
            </li>
          ))}
        </ul>
      )}

      {view === "preview" && <InvoicePreview data={data} />}
      {view === "json" && <pre style={preStyle}>{JSON.stringify(result, null, 2)}</pre>}
      {view === "ocr_format" && (
        <>
          <div className="small text-muted mt-2">
            The same result reshaped into the Textract-compatible envelope (
            <code>{"{ value:, confidence_score:, bounding_box: }"}</code>) that{" "}
            <code>Layers::Synthesize</code> consumes -- this is what would flow into the real
            pipeline if vendor parsers were wired in.
          </div>
          <pre style={preStyle}>{JSON.stringify(result.ocr_format, null, 2)}</pre>
        </>
      )}
    </div>
  );
};

export default TestResultView;
